<template>
    <div class="page-prodotto-detail">
      <prodotto-detail />
    </div>
  </template>
  
  <script>
  import ProdottoDetail from '@/components/details/KitDetail.vue'
  
  export default {
    name: 'ViewKitDetail',
    components: {
      ProdottoDetail,
    },
  
    data() {
      return {
        pageName: 'ProdottoDetail',
      }
    },
  
    created(){
  
    },
  
    mounted(){
      this.$eventBus.emit('page-change', {
        target: this,
        currentRoute: this.$router.currentRoute.value
      })
    },
    
  }
  </script>